//import React from 'react'
// import { NavLink } from "react-router-dom";

// const Landingpage = () => {
//   return (
//     <div>
//     <nav class="navbar navbar-expand-lg bg-body-tertiary">
//         <div class="container-fluid">
//             <a class="navbar-brand" href="#">
//                 <img src="./assets/images/arrogya.svg" alt="" width="200" height="40"
//                     class="d-inline-block align-text-top"/></a>
//             <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
//                 aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
//                 <span class="navbar-toggler-icon"></span>
//             </button>
//             <div class="collapse navbar-collapse" id="navbarNav">
//                 <ul class="navbar-nav">
//                     <li class="nav-item">
//                         <a class="nav-link active" aria-current="page" href="#">Home</a>
//                     </li>
//                     <li class="nav-item">
//                         <a class="nav-link" href="#">Service</a>
//                     </li>
//                     <li class="nav-item">
//                         <a class="nav-link" href="#">Features</a>
//                     </li>
//                     <li class="nav-item">
//                         <a class="nav-link" href="#">Client</a>
//                     </li>
//                     <li class="nav-item">
//                         <a class="nav-link" href="#">Price</a>
//                     </li>
//                 </ul>
//             </div>
//             {/* <button type="button" class="btn btn-primary login-btn">Login</button> */}
//             <NavLink to="/login" className="btn btn-primary login-btn">Login</NavLink>

//         </div>
//     </nav>
//     <div class="container">
//         <div class="row">
//             <div class="col-md-6">
//                 <div class="tag_line">
//                     <p class="tag_line_thin">your partner in <b>HEALTH</b></p>
//                     <p class="tag_line_bold">and <b>WELLNESS</b></p>
//                     <p class="para">
//                         Elevate healthcare efficiency with our SaaS hospital management software. Streamline operations
//                         seamlessly, empower care providers, and enhance patient experiences. Your all-in-one solution
//                         for a healthier, connected future.
//                     </p>
//                     <button class="book_demo">book demo</button>
//                     <div class="image_container">
//                         <a href="https://www.facebook.com/bbstechsolution/" target="_blank"><img class="image_spacing"
//                                 src="./assets/images/facebook.svg" /></a>
//                         <a href="https://www.instagram.com/bbstechsolution/" target="_blank"><img class="image_spacing"
//                                 src="./assets/images/instagram.svg" /></a>
//                         <a href="https://twitter.com/bbstechsolution" target="_blank"><img class="image_spacing"
//                                 src="./assets/images/twitter.svg" /></a>
//                         <a href="https://www.linkedin.com/company/82602705" target="_blank"><img class="image_spacing"
//                                 src="./assets/images/linked-in.svg" /></a>
//                     </div>
//                 </div>
//             </div>
//             <div class="col-md-6 hospital-img">
//                 <img src="./assets/images/arrogya-landing-01.svg" alt="" class="img-fluid"/>
//             </div>
//         </div>
//     </div>

//     {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"
//         integrity="sha384-C6RzsynM9kWDrMNeT87bh95OGNyZPhcTNXj1NW7RuBCsyN/o0jlpcV8Qyq46cDfL"
//         crossorigin="anonymous"></script> */}
//     </div>
//   )
// }

// export default Landingpage

// import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
// import {
//   ChevronDown,
//   Play,
//   Check,
//   Star,
//   Users,
//   Shield,
//   Clock,
//   Phone,
//   Mail,
//   MessageCircle,
//   ArrowRight,
//   Zap,
//   BarChart3,
//   FileText,
//   Calendar,
//   Pill,
//   UserCheck,
//   Menu,
//   X,
// } from "lucide-react";

// const LandingPage = () => {
//   const [activeTab, setActiveTab] = useState("opd");
//   const [activeFaq, setActiveFaq] = useState(null);
//   const [scrollY, setScrollY] = useState(0);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrollY(window.scrollY);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Add responsive styles
//   useEffect(() => {
//     const style = document.createElement("style");
//     style.textContent = `
//       @keyframes float {
//         0%, 100% { transform: translateY(0px); }
//         50% { transform: translateY(-6px); }
//       }

//       @media (max-width: 768px) {
//         .nav-menu { display: none !important; }
//         .login-btn-desktop { display: none !important; }
//         .mobile-menu-btn { display: block !important; }
//         .hero-content { grid-template-columns: 1fr !important; text-align: center !important; }
//         .hero-buttons { flex-direction: column !important; align-items: center !important; }
//         .trust-badges { grid-template-columns: repeat(3, 1fr) !important; }
//         .pain-grid { grid-template-columns: 1fr !important; }
//         .features-grid { grid-template-columns: 1fr !important; }
//         .pricing-grid { grid-template-columns: 1fr !important; }
//         .steps-grid { grid-template-columns: repeat(2, 1fr) !important; }
//         .trust-stats { grid-template-columns: repeat(2, 1fr) !important; }
//         .demo-buttons { flex-direction: column !important; align-items: center !important; }
//         .cta-buttons { flex-direction: column !important; align-items: center !important; }
//         .contact-info { flex-wrap: wrap !important; justify-content: center !important; }
//       }

//       @media (max-width: 480px) {
//         .trust-badges { grid-template-columns: 1fr !important; }
//         .steps-grid { grid-template-columns: 1fr !important; }
//         .trust-stats { grid-template-columns: 1fr !important; }
//         .contact-info { flex-direction: column !important; align-items: center !important; }
//         .hero-title { font-size: 1.8rem !important; line-height: 1.2 !important; }
//         .section-title { font-size: 1.6rem !important; }
//         .section-subtitle { font-size: 1rem !important; }
//         .hero-description { font-size: 1rem !important; }
//         .btn-primary, .btn-secondary { width: 100% !important; max-width: 300px !important; }
//         .demo-btn, .cta-btn { width: 100% !important; max-width: 280px !important; }
//         section { padding: 60px 0 40px !important; }
//         .max-width { padding: 0 16px !important; }
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   const features = [
//     {
//       icon: <UserCheck size={32} />,
//       title: "Patient Management",
//       description:
//         "Complete OPD/IPD patient records with digital history and seamless data management",
//     },
//     {
//       icon: <Calendar size={32} />,
//       title: "Appointment Scheduling",
//       description:
//         "Smart scheduling system with automated reminders and conflict resolution",
//     },
//     {
//       icon: <BarChart3 size={32} />,
//       title: "Billing & Reports",
//       description:
//         "GST-ready billing with comprehensive financial reports and analytics",
//     },
//     {
//       icon: <FileText size={32} />,
//       title: "Pathology & Radiology",
//       description:
//         "Digital lab reports and imaging management with instant access",
//     },
//     {
//       icon: <Pill size={32} />,
//       title: "Pharmacy Management",
//       description:
//         "Stock control, expiry tracking, and automated ordering system",
//     },
//     {
//       icon: <Shield size={32} />,
//       title: "Multi-Branch Access",
//       description:
//         "Role-based access control across multiple locations with security",
//     },
//   ];

//   const pricingPlans = [
//     {
//       name: "Basic",
//       beds: "5-10 Beds",
//       price: "1,499",
//       features: [
//         "Patient Management (OPD/IPD)",
//         "Basic Billing & GST Reports",
//         "Appointment Scheduling",
//         "Pharmacy Stock Management",
//         "24/7 Phone Support",
//         "Data Backup & Security",
//       ],
//       popular: false,
//     },
//     {
//       name: "Standard",
//       beds: "11-25 Beds",
//       price: "2,999",
//       features: [
//         "Everything in Basic",
//         "Pathology & Radiology Reports",
//         "Advanced Analytics Dashboard",
//         "Multi-user Access Control",
//         "WhatsApp Integration",
//         "Custom Report Generation",
//         "Priority Support",
//       ],
//       popular: true,
//     },
//     {
//       name: "Premium",
//       beds: "26-50 Beds",
//       price: "6,999",
//       features: [
//         "Everything in Standard",
//         "Multi-Branch Management",
//         "Blood Bank Management",
//         "OT Management System",
//         "Advanced Role Permissions",
//         "API Integration Support",
//         "Dedicated Account Manager",
//       ],
//       popular: false,
//     },
//   ];

//   const faqs = [
//     {
//       question: "Is patient data secure?",
//       answer:
//         "Yes, all patient data is encrypted and stored on secure cloud servers with regular backups and compliance with healthcare data protection standards including HIPAA guidelines.",
//     },
//     {
//       question: "Can I use this for small hospitals?",
//       answer:
//         "Absolutely! Aarogyasaarthi is specifically designed for 5-50 bed nursing homes and small hospitals with scalable features that grow with your needs.",
//     },
//     {
//       question: "How much training is required?",
//       answer:
//         "Minimal training required. Our team provides complete setup within 1 day and comprehensive staff training to get you started quickly with ongoing support.",
//     },
//     {
//       question: "Do you provide ongoing support?",
//       answer:
//         "Yes, we provide 24/7 technical support, regular updates, and dedicated customer success manager for Premium plans with guaranteed response times.",
//     },
//     {
//       question: "What about data migration from existing systems?",
//       answer:
//         "We provide complete data migration services from your existing systems at no additional cost, ensuring zero data loss during transition.",
//     },
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Navigation */}
//       <nav
//         style={{
//           ...styles.navbar,
//           background:
//             scrollY > 50
//               ? "rgba(255, 255, 255, 0.95)"
//               : "rgba(255, 255, 255, 0.9)",
//           boxShadow:
//             scrollY > 50
//               ? "0 8px 32px rgba(0, 0, 0, 0.12)"
//               : "0 2px 8px rgba(0, 0, 0, 0.04)",
//         }}
//       >
//         <div style={styles.navContainer}>
//           <div style={styles.logoSection}>
//             <img
//               src="./assets/images/arrogya.svg"
//               alt="Aarogyasaarthi"
//               width="200"
//               height="40"
//               style={styles.logoImage}
//             />
//           </div>

//           <div style={styles.navMenu} className="nav-menu">
//             <a href="#home" style={styles.navLink}>
//               Home
//             </a>
//             <a href="#features" style={styles.navLink}>
//               Features
//             </a>
//             <a href="#pricing" style={styles.navLink}>
//               Pricing
//             </a>
//             <a href="#demo" style={styles.navLink}>
//               Demo
//             </a>
//             <a href="#support" style={styles.navLink}>
//               Support
//             </a>
//           </div>

//           <NavLink
//             to="/login"
//             style={styles.loginBtn}
//             className="login-btn-desktop"
//           >
//             Login
//           </NavLink>

//           <button
//             style={styles.mobileMenuBtn}
//             className="mobile-menu-btn"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {mobileMenuOpen && (
//           <div style={styles.mobileMenu}>
//             <div style={styles.mobileMenuContent}>
//               <a
//                 href="#home"
//                 style={styles.mobileNavLink}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Home
//               </a>
//               <a
//                 href="#features"
//                 style={styles.mobileNavLink}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Features
//               </a>
//               <a
//                 href="#pricing"
//                 style={styles.mobileNavLink}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Pricing
//               </a>
//               <a
//                 href="#demo"
//                 style={styles.mobileNavLink}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Demo
//               </a>
//               <a
//                 href="#support"
//                 style={styles.mobileNavLink}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Support
//               </a>
//               <NavLink
//                 to="/login"
//                 style={styles.mobileLoginBtn}
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Login
//               </NavLink>
//             </div>
//           </div>
//         )}
//       </nav>

//       {/* Hero Section */}
//       <section id="home" style={styles.hero}>
//         <div style={styles.heroBackground}></div>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.heroContent} className="hero-content">
//             {/* Left Content */}
//             <div style={styles.heroText}>
//               <div style={styles.badge}>
//                 <Zap size={16} style={{ marginRight: "8px" }} />
//                 Setup in Just 1 Day
//               </div>

//               <h1 style={styles.heroTitle} className="hero-title">
//                 Smart Hospital Management Software for
//                 <span style={styles.gradientText}> 5–50 Bed</span> Nursing Homes
//               </h1>

//               <p style={styles.heroDescription} className="hero-description">
//                 Manage patients, billing, pharmacy & reports with ease. Digital
//                 transformation for healthcare providers with complete automation
//                 and compliance.
//               </p>

//               <div style={styles.heroButtons} className="hero-buttons">
//                 <button style={styles.btnPrimary} className="btn-primary">
//                   <Play size={20} style={{ marginRight: "8px" }} />
//                   Start 15-Day Free Trial
//                 </button>
//                 <button style={styles.btnSecondary} className="btn-secondary">
//                   Book a Demo
//                   <ArrowRight size={20} style={{ marginLeft: "8px" }} />
//                 </button>
//               </div>

//               {/* Trust Badges */}
//               <div style={styles.trustBadges} className="trust-badges">
//                 <div style={styles.trustBadge}>
//                   <div style={styles.trustNumber}>500+</div>
//                   <div style={styles.trustLabel}>Hospitals</div>
//                 </div>
//                 <div style={styles.trustBadge}>
//                   <div style={styles.trustNumber}>10,000+</div>
//                   <div style={styles.trustLabel}>Patients Registered</div>
//                 </div>
//                 <div style={styles.trustBadge}>
//                   <div style={styles.trustNumber}>99.9%</div>
//                   <div style={styles.trustLabel}>Uptime</div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Content - Hero Image */}
//             <div style={styles.heroImageSection}>
//               <div style={styles.heroImageCard}>
//                 <div style={styles.dashboardMockup}>
//                   <div style={styles.mockupHeader}>
//                     <div style={styles.mockupDots}>
//                       <span style={styles.dot}></span>
//                       <span style={styles.dot}></span>
//                       <span style={styles.dot}></span>
//                     </div>
//                     <span style={styles.mockupTitle}>Hospital Dashboard</span>
//                   </div>
//                   <div style={styles.mockupContent}>
//                     <div style={styles.mockupCards}>
//                       <div style={styles.mockupCard}>
//                         <Users size={20} />
//                         <div>
//                           <div style={styles.mockupCardTitle}>
//                             Total Patients
//                           </div>
//                           <div style={styles.mockupCardValue}>1,248</div>
//                         </div>
//                       </div>
//                       <div style={styles.mockupCard}>
//                         <Calendar size={20} />
//                         <div>
//                           <div style={styles.mockupCardTitle}>
//                             Today's Appointments
//                           </div>
//                           <div style={styles.mockupCardValue}>24</div>
//                         </div>
//                       </div>
//                     </div>
//                     <div style={styles.mockupChart}></div>
//                   </div>
//                 </div>
//                 <div style={styles.floatingBadge1}>
//                   <Check size={24} />
//                 </div>
//                 <div style={styles.floatingBadge2}>
//                   <Shield size={24} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pain Points → Solution Section */}
//       <section style={styles.painSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle} className="section-title">
//               From Manual Processes to Digital Excellence
//             </h2>
//             <p style={styles.sectionSubtitle} className="section-subtitle">
//               Transform your hospital operations with our comprehensive digital
//               solution
//             </p>
//           </div>

//           <div style={styles.painGrid} className="pain-grid">
//             {/* Challenges */}
//             <div>
//               <h3 style={styles.painTitle}>
//                 <span style={styles.painIcon}>❌</span>
//                 Current Challenges
//               </h3>
//               <div style={styles.painList}>
//                 {[
//                   "Manual billing & paper records leading to errors",
//                   "No proper patient history tracking system",
//                   "Stock mismanagement in pharmacy inventory",
//                   "Compliance issues with certificates & reports",
//                   "Time-consuming appointment scheduling",
//                   "Lack of real-time business insights",
//                 ].map((challenge, index) => (
//                   <div key={index} style={styles.challengeCard}>
//                     <p style={styles.cardText}>{challenge}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Solutions */}
//             <div>
//               <h3 style={styles.solutionTitle}>
//                 <span style={styles.solutionIcon}>✅</span>
//                 Aarogyasaarthi Solutions
//               </h3>
//               <div style={styles.painList}>
//                 {[
//                   "Complete digital patient records with history",
//                   "GST-ready billing & automated financial reports",
//                   "Smart pharmacy & stock control system",
//                   "Auto-generated birth & death certificates",
//                   "Intelligent appointment scheduling system",
//                   "Real-time analytics & business insights",
//                 ].map((solution, index) => (
//                   <div key={index} style={styles.solutionCard}>
//                     <p style={styles.cardText}>{solution}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Social Proof / Trust Section */}
//       <section style={styles.trustSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.trustContent}>
//             <h3 style={styles.trustTitle}>
//               Trusted by Healthcare Providers Across India
//             </h3>
//             <div style={styles.trustStats} className="trust-stats">
//               <div style={styles.trustStat}>
//                 <div style={styles.trustStatNumber}>500+</div>
//                 <div style={styles.trustStatLabel}>Hospitals Trust Us</div>
//               </div>
//               <div style={styles.trustStat}>
//                 <div style={styles.trustStatNumber}>10,000+</div>
//                 <div style={styles.trustStatLabel}>Patients Managed Daily</div>
//               </div>
//               <div style={styles.trustStat}>
//                 <div style={styles.trustStatNumber}>99.9%</div>
//                 <div style={styles.trustStatLabel}>System Uptime</div>
//               </div>
//               <div style={styles.trustStat}>
//                 <div style={styles.trustStatNumber}>24/7</div>
//                 <div style={styles.trustStatLabel}>Support Available</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Core Features Section */}
//       <section id="features" style={styles.featuresSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle} className="section-title">
//               Complete Hospital Management Suite
//             </h2>
//             <p style={styles.sectionSubtitle} className="section-subtitle">
//               Everything you need to run your hospital efficiently in one
//               integrated platform
//             </p>
//           </div>

//           <div style={styles.featuresGrid} className="features-grid">
//             {features.map((feature, index) => (
//               <div key={index} style={styles.featureCard}>
//                 <div style={styles.featureIcon}>{feature.icon}</div>
//                 <h3 style={styles.featureTitle}>{feature.title}</h3>
//                 <p style={styles.featureDescription}>{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       <section id="pricing" style={styles.pricingSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle} className="section-title">
//               Simple, Transparent Pricing
//             </h2>
//             <p style={styles.sectionSubtitle} className="section-subtitle">
//               Choose the perfect plan for your hospital size and requirements
//             </p>
//           </div>

//           <div style={styles.pricingGrid} className="pricing-grid">
//             {pricingPlans.map((plan, index) => (
//               <div
//                 key={index}
//                 style={{
//                   ...styles.pricingCard,
//                   ...(plan.popular ? styles.popularCard : {}),
//                 }}
//               >
//                 {plan.popular && (
//                   <div style={styles.popularBadge}>
//                     <Star size={16} style={{ marginRight: "4px" }} />
//                     Most Popular
//                   </div>
//                 )}

//                 <div style={styles.pricingHeader}>
//                   <h3 style={styles.planName}>{plan.name}</h3>
//                   <p style={styles.planBeds}>{plan.beds}</p>
//                   <div style={styles.planPrice}>
//                     <span style={styles.priceAmount}>₹{plan.price}</span>
//                     <span style={styles.priceUnit}>/month</span>
//                   </div>
//                 </div>

//                 <ul style={styles.featuresList}>
//                   {plan.features.map((feature, fIndex) => (
//                     <li key={fIndex} style={styles.featureItem}>
//                       <Check size={18} style={styles.checkIcon} />
//                       <span style={styles.featureText}>{feature}</span>
//                     </li>
//                   ))}
//                 </ul>

//                 <button
//                   style={
//                     plan.popular ? styles.popularButton : styles.pricingButton
//                   }
//                 >
//                   Get Started
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Onboarding Steps */}
//       <section style={styles.onboardingSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle} className="section-title">
//               Get Started in 4 Simple Steps
//             </h2>
//             <p style={styles.sectionSubtitle} className="section-subtitle">
//               From signup to going live in just one day
//             </p>
//           </div>

//           <div style={styles.stepsGrid} className="steps-grid">
//             {[
//               {
//                 icon: <UserCheck size={32} />,
//                 title: "Sign Up",
//                 desc: "Create your account and choose your plan",
//                 step: "1",
//               },
//               {
//                 icon: <Clock size={32} />,
//                 title: "Setup in 1 Day",
//                 desc: "Our team configures everything for you",
//                 step: "2",
//               },
//               {
//                 icon: <Users size={32} />,
//                 title: "Train Staff",
//                 desc: "Comprehensive training for your team",
//                 step: "3",
//               },
//               {
//                 icon: <Zap size={32} />,
//                 title: "Go Live",
//                 desc: "Start managing your hospital digitally",
//                 step: "4",
//               },
//             ].map((step, index) => (
//               <div key={index} style={styles.stepCard}>
//                 <div style={styles.stepNumber}>{step.step}</div>
//                 <div style={styles.stepIcon}>{step.icon}</div>
//                 <h3 style={styles.stepTitle}>{step.title}</h3>
//                 <p style={styles.stepDesc}>{step.desc}</p>
//               </div>
//             ))}
//           </div>

//           <div style={styles.supportBadges}>
//             <div style={styles.supportBadgeContainer}>
//               <div style={styles.supportBadge}>
//                 <Shield size={24} style={styles.supportIcon} />
//                 <span style={styles.supportText}>24/7 Support</span>
//               </div>
//               <div style={styles.supportBadge}>
//                 <Check size={24} style={styles.supportIconGreen} />
//                 <span style={styles.supportText}>Data Security</span>
//               </div>
//               <div style={styles.supportBadge}>
//                 <Star size={24} style={styles.supportIconYellow} />
//                 <span style={styles.supportText}>Free Updates</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Demo Section */}
//       <section id="demo" style={styles.demoSection}>
//         <div style={styles.maxWidth} className="max-width">
//           <div style={styles.demoContent}>
//             <h2 style={styles.demoTitle} className="section-title">
//               See How Aarogyasaarthi Makes Hospital Operations Seamless
//             </h2>
//             <p style={styles.demoSubtitle} className="section-subtitle">
//               Watch our platform in action and discover how it can transform
//               your healthcare practice
//             </p>
//             <div style={styles.demoVideoCard}>
//               <div style={styles.demoVideoPlaceholder}>
//                 <Play size={64} style={styles.playIcon} />
//                 <p style={styles.demoVideoText}>Watch Demo Video</p>
//               </div>
//             </div>
//             <div style={styles.demoButtons} className="demo-buttons">
//               <button style={styles.demoPrimaryBtn} className="demo-btn">
//                 <Play size={20} style={{ marginRight: "8px" }} />
//                 Watch Full Demo
//               </button>
//               <button style={styles.demoSecondaryBtn} className="demo-btn">
//                 Schedule Live Demo
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ Section */}
//       <section id="faq" style={styles.faqSection}>
//         <div style={styles.faqContainer}>
//           <div style={styles.sectionHeader}>
//             <h2 style={styles.sectionTitle} className="section-title">
//               Frequently Asked Questions
//             </h2>
//             <p style={styles.sectionSubtitle} className="section-subtitle">
//               Everything you need to know about Aarogyasaarthi
//             </p>
//           </div>

//           <div style={styles.faqList}>
//             {faqs.map((faq, index) => (
//               <div key={index} style={styles.faqItem}>
//                 <button
//                   onClick={() =>
//                     setActiveFaq(activeFaq === index ? null : index)
//                   }
//                   style={styles.faqQuestion}
//                 >
//                   <h3 style={styles.faqQuestionText}>{faq.question}</h3>
//                   <ChevronDown
//                     size={20}
//                     style={{
//                       ...styles.faqIcon,
//                       transform:
//                         activeFaq === index ? "rotate(180deg)" : "rotate(0deg)",
//                     }}
//                   />
//                 </button>
//                 {activeFaq === index && (
//                   <div style={styles.faqAnswer}>
//                     <p style={styles.faqAnswerText}>{faq.answer}</p>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Final CTA Section */}
//       <section id="support" style={styles.ctaSection}>
//         <div style={styles.ctaContainer}>
//           <h2 style={styles.ctaTitle} className="section-title">
//             Run Your Hospital Smarter with Aarogyasaarthi
//           </h2>
//           <p style={styles.ctaSubtitle} className="section-subtitle">
//             Join hundreds of healthcare providers who have transformed their
//             operations with our platform
//           </p>

//           <div style={styles.ctaButtons} className="cta-buttons">
//             <button style={styles.ctaPrimary} className="cta-btn">
//               Start Free Trial
//             </button>
//             <button style={styles.ctaSecondary} className="cta-btn">
//               Schedule Demo
//             </button>
//           </div>

//           <div style={styles.contactInfo} className="contact-info">
//             <a href="tel:+916361748291" style={styles.contactItem}>
//               <Phone size={20} style={{ marginRight: "8px" }} />
//               +91 6361748291
//             </a>
//             <a href="info@bbstechsolutions.com" style={styles.contactItem}>
//               <Mail size={20} style={{ marginRight: "8px" }} />
//               info@bbstechsolutions.com
//             </a>
//             <a href="https://wa.me/916361748291" style={styles.contactItem}>
//               <MessageCircle size={20} style={{ marginRight: "8px" }} />
//               WhatsApp Support
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: "100vh",
//     backgroundColor: "#ffffff",
//     fontFamily:
//       'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     lineHeight: "1.6",
//     color: "#333",
//   },

//   // Navigation Styles
//   navbar: {
//     position: "fixed",
//     width: "100%",
//     top: 0,
//     zIndex: 1000,
//     padding: "16px 0",
//     backdropFilter: "blur(10px)",
//     transition: "all 0.3s ease",
//     borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
//   },
//   navContainer: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "0 20px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   logoSection: {
//     display: "flex",
//     alignItems: "center",
//   },
//   logoImage: {
//     maxHeight: "40px",
//     width: "auto",
//   },
//   navMenu: {
//     display: "flex",
//     alignItems: "center",
//     gap: "32px",
//   },
//   navLink: {
//     textDecoration: "none",
//     color: "#64748b",
//     fontWeight: "500",
//     fontSize: "16px",
//     transition: "color 0.3s ease",
//     cursor: "pointer",
//   },
//   loginBtn: {
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     color: "white",
//     padding: "12px 28px",
//     border: "none",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//     boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
//     textDecoration: "none",
//     display: "inline-block",
//   },
//   mobileMenuBtn: {
//     display: "none",
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//     color: "#64748b",
//   },
//   mobileMenu: {
//     position: "absolute",
//     top: "100%",
//     left: 0,
//     right: 0,
//     background: "white",
//     borderTop: "1px solid #e2e8f0",
//     boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
//     zIndex: 999,
//   },
//   mobileMenuContent: {
//     padding: "16px 20px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "12px",
//   },
//   mobileNavLink: {
//     textDecoration: "none",
//     color: "#64748b",
//     fontWeight: "500",
//     fontSize: "16px",
//     padding: "12px 0",
//     borderBottom: "1px solid #f1f5f9",
//     cursor: "pointer",
//   },
//   mobileLoginBtn: {
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     color: "white",
//     padding: "12px 24px",
//     border: "none",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     marginTop: "8px",
//     textDecoration: "none",
//     display: "block",
//     textAlign: "center",
//     width: "100%",
//   },

//   // Hero Section Styles
//   hero: {
//     background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//     padding: "120px 0 60px",
//     position: "relative",
//     overflow: "hidden",
//     minHeight: "90vh",
//     display: "flex",
//     alignItems: "center",
//   },
//   heroBackground: {
//     position: "absolute",
//     inset: 0,
//     background:
//       "linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%)",
//     backdropFilter: "blur(100px)",
//   },
//   maxWidth: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "0 20px",
//     position: "relative",
//     zIndex: 1,
//   },
//   heroContent: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "64px",
//     alignItems: "center",
//   },
//   heroText: {
//     zIndex: 2,
//     position: "relative",
//   },
//   badge: {
//     display: "inline-flex",
//     alignItems: "center",
//     background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
//     color: "#16a34a",
//     borderRadius: "25px",
//     padding: "10px 20px",
//     fontSize: "14px",
//     fontWeight: "600",
//     marginBottom: "24px",
//     border: "1px solid rgba(22, 163, 74, 0.2)",
//   },
//   heroTitle: {
//     fontSize: "3.5rem",
//     fontWeight: "800",
//     lineHeight: "1.1",
//     marginBottom: "24px",
//     color: "#1e293b",
//   },
//   gradientText: {
//     background: "linear-gradient(135deg, #16a34a 0%, #2563eb 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     backgroundClip: "text",
//   },
//   heroDescription: {
//     fontSize: "1.25rem",
//     marginBottom: "40px",
//     color: "#64748b",
//     lineHeight: "1.7",
//     maxWidth: "540px",
//   },
//   heroButtons: {
//     display: "flex",
//     gap: "16px",
//     marginBottom: "48px",
//   },
//   btnPrimary: {
//     background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
//     color: "white",
//     padding: "18px 36px",
//     border: "none",
//     borderRadius: "50px",
//     fontSize: "18px",
//     fontWeight: "600",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: "all 0.3s ease",
//     boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
//   },
//   btnSecondary: {
//     background: "transparent",
//     color: "#2563eb",
//     padding: "18px 36px",
//     border: "2px solid #2563eb",
//     borderRadius: "50px",
//     fontSize: "18px",
//     fontWeight: "600",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: "all 0.3s ease",
//   },
//   trustBadges: {
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "32px",
//     marginTop: "32px",
//   },
//   trustBadge: {
//     textAlign: "center",
//   },
//   trustNumber: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     marginBottom: "8px",
//     color: "#1e293b",
//     background: "linear-gradient(135deg, #2563eb 0%, #16a34a 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     backgroundClip: "text",
//   },
//   trustLabel: {
//     fontSize: "14px",
//     color: "#64748b",
//     fontWeight: "500",
//   },

//   // Hero Image Section
//   heroImageSection: {
//     position: "relative",
//   },
//   heroImageCard: {
//     position: "relative",
//     background: "rgba(255, 255, 255, 0.8)",
//     backdropFilter: "blur(20px)",
//     borderRadius: "24px",
//     padding: "24px",
//     border: "1px solid rgba(255, 255, 255, 0.3)",
//     boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
//     transition: "transform 0.3s ease",
//   },
//   dashboardMockup: {
//     background: "white",
//     borderRadius: "16px",
//     overflow: "hidden",
//     boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
//   },
//   mockupHeader: {
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     padding: "16px 20px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//   },
//   mockupDots: {
//     display: "flex",
//     gap: "6px",
//   },
//   dot: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     background: "rgba(255, 255, 255, 0.3)",
//   },
//   mockupTitle: {
//     color: "white",
//     fontSize: "14px",
//     fontWeight: "600",
//   },
//   mockupContent: {
//     padding: "20px",
//   },
//   mockupCards: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "12px",
//     marginBottom: "20px",
//   },
//   mockupCard: {
//     background: "#f8fafc",
//     padding: "16px",
//     borderRadius: "12px",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//   },
//   mockupCardTitle: {
//     fontSize: "12px",
//     color: "#64748b",
//     marginBottom: "4px",
//   },
//   mockupCardValue: {
//     fontSize: "18px",
//     fontWeight: "700",
//     color: "#1e293b",
//   },
//   mockupChart: {
//     height: "80px",
//     background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
//     borderRadius: "8px",
//     position: "relative",
//   },
//   floatingBadge1: {
//     position: "absolute",
//     top: "-12px",
//     right: "-12px",
//     background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
//     color: "white",
//     padding: "12px",
//     borderRadius: "50%",
//     boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
//     animation: "float 3s ease-in-out infinite",
//   },
//   floatingBadge2: {
//     position: "absolute",
//     bottom: "-12px",
//     left: "-12px",
//     background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
//     color: "white",
//     padding: "12px",
//     borderRadius: "50%",
//     boxShadow: "0 8px 25px rgba(37, 99, 235, 0.3)",
//     animation: "float 3s ease-in-out infinite 1.5s",
//   },

//   // Pain Points Section
//   painSection: {
//     padding: "80px 0",
//     background: "#f8fafc",
//   },
//   sectionHeader: {
//     textAlign: "center",
//     marginBottom: "60px",
//   },
//   sectionTitle: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     color: "#1e293b",
//     marginBottom: "20px",
//     lineHeight: "1.2",
//   },
//   sectionSubtitle: {
//     fontSize: "1.25rem",
//     color: "#64748b",
//     maxWidth: "600px",
//     margin: "0 auto",
//     lineHeight: "1.6",
//   },
//   painGrid: {
//     display: "grid",
//     gridTemplateColumns: "1fr 1fr",
//     gap: "60px",
//   },
//   painTitle: {
//     fontSize: "1.5rem",
//     fontWeight: "700",
//     color: "#dc2626",
//     marginBottom: "24px",
//     display: "flex",
//     alignItems: "center",
//   },
//   solutionTitle: {
//     fontSize: "1.5rem",
//     fontWeight: "700",
//     color: "#16a34a",
//     marginBottom: "24px",
//     display: "flex",
//     alignItems: "center",
//   },
//   painIcon: {
//     background: "#fee2e2",
//     padding: "12px",
//     borderRadius: "50%",
//     marginRight: "16px",
//     fontSize: "20px",
//   },
//   solutionIcon: {
//     background: "#dcfce7",
//     padding: "12px",
//     borderRadius: "50%",
//     marginRight: "16px",
//     fontSize: "20px",
//   },
//   painList: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//   },
//   challengeCard: {
//     background: "white",
//     padding: "20px",
//     borderRadius: "12px",
//     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
//     borderLeft: "4px solid #dc2626",
//     transition: "all 0.3s ease",
//   },
//   solutionCard: {
//     background: "white",
//     padding: "20px",
//     borderRadius: "12px",
//     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
//     borderLeft: "4px solid #16a34a",
//     transition: "all 0.3s ease",
//   },
//   cardText: {
//     margin: 0,
//     color: "#374151",
//     lineHeight: "1.6",
//     fontSize: "16px",
//   },

//   // Trust Section
//   trustSection: {
//     padding: "60px 0",
//     background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
//     color: "white",
//   },
//   trustContent: {
//     textAlign: "center",
//   },
//   trustTitle: {
//     fontSize: "2rem",
//     fontWeight: "700",
//     marginBottom: "40px",
//   },
//   trustStats: {
//     display: "grid",
//     gridTemplateColumns: "repeat(4, 1fr)",
//     gap: "32px",
//   },
//   trustStat: {
//     textAlign: "center",
//     padding: "20px",
//   },
//   trustStatNumber: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     marginBottom: "8px",
//     background: "linear-gradient(135deg, #16a34a 0%, #2563eb 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     backgroundClip: "text",
//   },
//   trustStatLabel: {
//     fontSize: "14px",
//     opacity: 0.8,
//   },

//   // Features Section
//   featuresSection: {
//     padding: "80px 0",
//     background: "white",
//   },
//   featuresGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//     gap: "32px",
//   },
//   featureCard: {
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     color: "white",
//     padding: "32px",
//     borderRadius: "16px",
//     textAlign: "center",
//     transition: "all 0.3s ease",
//     position: "relative",
//     overflow: "hidden",
//   },
//   featureIcon: {
//     background: "rgba(255, 255, 255, 0.2)",
//     borderRadius: "16px",
//     width: "64px",
//     height: "64px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     margin: "0 auto 20px",
//     backdropFilter: "blur(10px)",
//   },
//   featureTitle: {
//     fontSize: "1.25rem",
//     fontWeight: "700",
//     marginBottom: "16px",
//   },
//   featureDescription: {
//     opacity: 0.9,
//     lineHeight: "1.6",
//     fontSize: "16px",
//   },

//   // Pricing Section
//   pricingSection: {
//     padding: "80px 0",
//     background: "#f8fafc",
//   },
//   pricingGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "32px",
//   },
//   pricingCard: {
//     background: "white",
//     borderRadius: "16px",
//     padding: "32px",
//     textAlign: "center",
//     boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
//     border: "1px solid #e2e8f0",
//     position: "relative",
//     transition: "all 0.3s ease",
//   },
//   popularCard: {
//     border: "2px solid #2563eb",
//     transform: "scale(1.02)",
//     boxShadow: "0 16px 32px rgba(37, 99, 235, 0.2)",
//   },
//   popularBadge: {
//     position: "absolute",
//     top: "-12px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     color: "white",
//     padding: "8px 20px",
//     borderRadius: "20px",
//     fontSize: "14px",
//     fontWeight: "600",
//     display: "flex",
//     alignItems: "center",
//   },
//   pricingHeader: {
//     marginBottom: "24px",
//   },
//   planName: {
//     fontSize: "1.5rem",
//     fontWeight: "700",
//     color: "#1e293b",
//     marginBottom: "8px",
//   },
//   planBeds: {
//     fontSize: "14px",
//     color: "#64748b",
//     marginBottom: "16px",
//   },
//   planPrice: {
//     marginBottom: "8px",
//   },
//   priceAmount: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     color: "#1e293b",
//   },
//   priceUnit: {
//     fontSize: "16px",
//     color: "#64748b",
//     fontWeight: "500",
//   },
//   featuresList: {
//     listStyle: "none",
//     padding: 0,
//     margin: "0 0 24px 0",
//     textAlign: "left",
//   },
//   featureItem: {
//     display: "flex",
//     alignItems: "flex-start",
//     marginBottom: "10px",
//     gap: "8px",
//   },
//   checkIcon: {
//     color: "#16a34a",
//     marginTop: "2px",
//     flexShrink: 0,
//   },
//   featureText: {
//     color: "#374151",
//     fontSize: "15px",
//     lineHeight: "1.5",
//   },
//   pricingButton: {
//     background: "transparent",
//     color: "#2563eb",
//     border: "2px solid #2563eb",
//     padding: "12px 24px",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     width: "100%",
//     transition: "all 0.3s ease",
//   },
//   popularButton: {
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     color: "white",
//     border: "none",
//     padding: "12px 24px",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     width: "100%",
//     transition: "all 0.3s ease",
//     boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
//   },

//   // Onboarding Steps
//   onboardingSection: {
//     padding: "80px 0",
//     background: "white",
//   },
//   stepsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//     gap: "32px",
//     marginBottom: "48px",
//   },
//   stepCard: {
//     textAlign: "center",
//     position: "relative",
//     padding: "24px 16px",
//   },
//   stepNumber: {
//     position: "absolute",
//     top: "-12px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
//     color: "white",
//     width: "28px",
//     height: "28px",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "12px",
//     fontWeight: "700",
//   },
//   stepIcon: {
//     background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
//     borderRadius: "12px",
//     width: "64px",
//     height: "64px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     margin: "0 auto 16px",
//     color: "#475569",
//   },
//   stepTitle: {
//     fontSize: "1.1rem",
//     fontWeight: "700",
//     marginBottom: "8px",
//     color: "#1e293b",
//   },
//   stepDesc: {
//     color: "#64748b",
//     lineHeight: "1.5",
//     fontSize: "14px",
//   },
//   supportBadges: {
//     display: "flex",
//     justifyContent: "center",
//   },
//   supportBadgeContainer: {
//     display: "flex",
//     gap: "24px",
//     flexWrap: "wrap",
//     justifyContent: "center",
//   },
//   supportBadge: {
//     display: "flex",
//     alignItems: "center",
//     background: "#f8fafc",
//     padding: "10px 16px",
//     borderRadius: "20px",
//     border: "1px solid #e2e8f0",
//   },
//   supportIcon: {
//     color: "#2563eb",
//     marginRight: "6px",
//   },
//   supportIconGreen: {
//     color: "#16a34a",
//     marginRight: "6px",
//   },
//   supportIconYellow: {
//     color: "#eab308",
//     marginRight: "6px",
//   },
//   supportText: {
//     color: "#374151",
//     fontSize: "13px",
//     fontWeight: "500",
//   },

//   // Demo Section
//   demoSection: {
//     padding: "80px 0",
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     color: "white",
//   },
//   demoContent: {
//     textAlign: "center",
//   },
//   demoTitle: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     marginBottom: "20px",
//     lineHeight: "1.2",
//   },
//   demoSubtitle: {
//     fontSize: "1.25rem",
//     marginBottom: "40px",
//     opacity: 0.9,
//     maxWidth: "600px",
//     margin: "0 auto 40px",
//   },
//   demoVideoCard: {
//     background: "rgba(255, 255, 255, 0.1)",
//     backdropFilter: "blur(20px)",
//     borderRadius: "16px",
//     padding: "32px",
//     marginBottom: "32px",
//     border: "1px solid rgba(255, 255, 255, 0.2)",
//   },
//   demoVideoPlaceholder: {
//     background: "rgba(255, 255, 255, 0.05)",
//     borderRadius: "12px",
//     padding: "48px 20px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   playIcon: {
//     background: "rgba(255, 255, 255, 0.2)",
//     borderRadius: "50%",
//     padding: "16px",
//     marginBottom: "12px",
//   },
//   demoVideoText: {
//     fontSize: "16px",
//     fontWeight: "600",
//     margin: 0,
//   },
//   demoButtons: {
//     display: "flex",
//     gap: "16px",
//     justifyContent: "center",
//   },
//   demoPrimaryBtn: {
//     background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
//     color: "white",
//     padding: "14px 28px",
//     border: "none",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     transition: "all 0.3s ease",
//   },
//   demoSecondaryBtn: {
//     background: "transparent",
//     color: "white",
//     padding: "14px 28px",
//     border: "2px solid rgba(255, 255, 255, 0.3)",
//     borderRadius: "25px",
//     fontSize: "16px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },

//   // FAQ Section
//   faqSection: {
//     padding: "80px 0",
//     background: "white",
//   },
//   faqContainer: {
//     maxWidth: "800px",
//     margin: "0 auto",
//     padding: "0 20px",
//   },
//   faqList: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "8px",
//   },
//   faqItem: {
//     background: "white",
//     border: "1px solid #e2e8f0",
//     borderRadius: "12px",
//     overflow: "hidden",
//     marginBottom: "8px",
//   },
//   faqQuestion: {
//     width: "100%",
//     padding: "20px",
//     background: "transparent",
//     border: "none",
//     cursor: "pointer",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     transition: "all 0.3s ease",
//   },
//   faqQuestionText: {
//     fontSize: "17px",
//     fontWeight: "600",
//     color: "#1e293b",
//     textAlign: "left",
//     margin: 0,
//   },
//   faqIcon: {
//     color: "#64748b",
//     transition: "transform 0.3s ease",
//     flexShrink: 0,
//     marginLeft: "12px",
//   },
//   faqAnswer: {
//     padding: "0 20px 20px",
//     borderTop: "1px solid #f1f5f9",
//   },
//   faqAnswerText: {
//     color: "#64748b",
//     lineHeight: "1.6",
//     margin: 0,
//     fontSize: "15px",
//   },

//   // Final CTA Section
//   ctaSection: {
//     padding: "80px 0",
//     background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
//     color: "white",
//   },
//   ctaContainer: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "0 20px",
//     textAlign: "center",
//   },
//   ctaTitle: {
//     fontSize: "2.5rem",
//     fontWeight: "800",
//     marginBottom: "20px",
//     lineHeight: "1.2",
//   },
//   ctaSubtitle: {
//     fontSize: "1.25rem",
//     marginBottom: "40px",
//     opacity: 0.9,
//     maxWidth: "600px",
//     margin: "0 auto 40px",
//   },
//   ctaButtons: {
//     display: "flex",
//     gap: "16px",
//     justifyContent: "center",
//     marginBottom: "48px",
//   },
//   ctaPrimary: {
//     background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
//     color: "white",
//     padding: "16px 32px",
//     border: "none",
//     borderRadius: "25px",
//     fontSize: "18px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//     boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
//   },
//   ctaSecondary: {
//     background: "transparent",
//     color: "white",
//     padding: "16px 32px",
//     border: "2px solid rgba(255, 255, 255, 0.3)",
//     borderRadius: "25px",
//     fontSize: "18px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   },
//   contactInfo: {
//     display: "flex",
//     gap: "24px",
//     justifyContent: "center",
//     flexWrap: "wrap",
//   },
//   contactItem: {
//     display: "flex",
//     alignItems: "center",
//     color: "white",
//     textDecoration: "none",
//     fontSize: "16px",
//     fontWeight: "500",
//     padding: "12px 20px",
//     background: "rgba(255, 255, 255, 0.1)",
//     borderRadius: "25px",
//     transition: "all 0.3s ease",
//   },
// };

// export default LandingPage;

import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  ChevronDown,
  Play,
  Check,
  Star,
  Users,
  Shield,
  Clock,
  Phone,
  Mail,
  MessageCircle,
  ArrowRight,
  Zap,
  BarChart3,
  FileText,
  Calendar,
  Pill,
  UserCheck,
  Menu,
  X,
  Monitor,
  Smartphone,
  FileCheck,
} from "lucide-react";

const LandingPage = () => {
  const [activeTab, setActiveTab] = useState("opd");
  const [activeFaq, setActiveFaq] = useState(null);
  const [scrollY, setScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    hospitalName: "",
    city: "",
    bedCount: "",
    mobile: "",
    currentSystem: "",
    role: "",
    preferredTime: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const WHATSAPP_NUMBER = "916361748291";
  const WHATSAPP_MESSAGE = encodeURIComponent(
    "Hi, I want demo and go-live plan for 11-25 bed nursing home"
  );
  const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Track event
    if (window.gtag) {
      window.gtag("event", "submit_lead_form", {
        event_category: "Lead Generation",
        event_label: "Demo Form Submission",
      });
    }

    // In production, send to your backend/email service
    console.log("Form submitted:", formData);

    // Show success message
    setFormSubmitted(true);

    // Redirect to WhatsApp after 2 seconds
    setTimeout(() => {
      const customMessage = encodeURIComponent(
        `Hi, I'm ${formData.name} from ${formData.hospitalName}, ${formData.city}. We have ${formData.bedCount} beds. I'd like to book a demo and learn about the 14-day go-live plan.`
      );
      window.open(
        `https://wa.me/${WHATSAPP_NUMBER}?text=${customMessage}`,
        "_blank"
      );
    }, 2000);
  };

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Add responsive styles
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-6px); }
      }
      
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
      
      @media (max-width: 768px) {
        .nav-menu { display: none !important; }
        .login-btn-desktop { display: none !important; }
        .mobile-menu-btn { display: block !important; }
        .hero-content { grid-template-columns: 1fr !important; text-align: center !important; }
        .hero-buttons { flex-direction: column !important; align-items: center !important; }
        .trust-badges { grid-template-columns: repeat(3, 1fr) !important; }
        .trust-bullets { grid-template-columns: 1fr !important; }
        .pain-grid { grid-template-columns: 1fr !important; }
        .features-grid { grid-template-columns: 1fr !important; }
        .pricing-grid { grid-template-columns: 1fr !important; }
        .steps-grid { grid-template-columns: repeat(2, 1fr) !important; }
        .trust-stats { grid-template-columns: repeat(2, 1fr) !important; }
        .demo-buttons { flex-direction: column !important; align-items: center !important; }
        .cta-buttons { flex-direction: column !important; align-items: center !important; }
        .contact-info { flex-wrap: wrap !important; justify-content: center !important; }
        .hero-image-section { display: none !important; }
        .mobile-bottom-bar { display: grid !important; }
        .form-row { grid-template-columns: 1fr !important; }
        body { padding-bottom: 70px !important; }
      }
      
      @media (max-width: 480px) {
        .trust-badges { grid-template-columns: 1fr !important; }
        .steps-grid { grid-template-columns: 1fr !important; }
        .trust-stats { grid-template-columns: 1fr !important; }
        .contact-info { flex-direction: column !important; align-items: center !important; }
        .hero-title { font-size: 1.8rem !important; line-height: 1.2 !important; }
        .section-title { font-size: 1.6rem !important; }
        .section-subtitle { font-size: 1rem !important; }
        .hero-description { font-size: 1rem !important; }
        .btn-primary, .btn-secondary { width: 100% !important; max-width: 300px !important; }
        .demo-btn, .cta-btn { width: 100% !important; max-width: 280px !important; }
        section { padding: 60px 0 40px !important; }
        .max-width { padding: 0 16px !important; }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const features = [
    {
      icon: <UserCheck size={32} />,
      title: "Patient Management (OPD/IPD)",
      description:
        "Complete OPD/IPD patient records with digital history and seamless data management",
      priority: true,
    },
    {
      icon: <BarChart3 size={32} />,
      title: "Billing & Reports",
      description:
        "GST-ready billing with comprehensive financial reports and analytics",
      priority: true,
    },
    {
      icon: <Pill size={32} />,
      title: "Pharmacy Management",
      description:
        "Stock control, expiry tracking, and automated ordering system",
      priority: true,
    },
    {
      icon: <Calendar size={32} />,
      title: "Appointment Scheduling",
      description:
        "Smart scheduling system with automated reminders and conflict resolution",
      priority: true,
    },
    {
      icon: <BarChart3 size={32} />,
      title: "Analytics Dashboard",
      description:
        "Real-time business insights and performance metrics at your fingertips",
      priority: true,
    },
    {
      icon: <Shield size={32} />,
      title: "User Access Control & WhatsApp",
      description:
        "Role-based access control with WhatsApp integration for alerts",
      priority: true,
    },
    {
      icon: <FileText size={32} />,
      title: "Pathology & Radiology",
      description:
        "Digital lab reports and imaging management with instant access",
      priority: false,
    },
    {
      icon: <Shield size={32} />,
      title: "Multi-Branch Management",
      description:
        "Manage multiple locations with centralized control - Premium feature",
      premium: true,
    },
  ];

  const pricingPlans = [
    {
      name: "Basic",
      beds: "5-10 Beds",
      price: "1,499",
      features: [
        "Patient Management (OPD/IPD)",
        "Basic Billing & GST Reports",
        "Appointment Scheduling",
        "Pharmacy Stock Management",
        "24/7 Phone Support",
        "Data Backup & Security",
      ],
      popular: false,
    },
    {
      name: "Standard",
      beds: "11-25 Beds",
      price: "2,999",
      features: [
        "Everything in Basic",
        "Pathology & Radiology Reports",
        "Advanced Analytics Dashboard",
        "Multi-user Access Control",
        "WhatsApp Integration",
        "Custom Report Generation",
        "Priority Support",
      ],
      popular: true,
    },
    {
      name: "Premium",
      beds: "26-50 Beds",
      price: "6,999",
      features: [
        "Everything in Standard",
        "Multi-Branch Management",
        "Blood Bank Management",
        "OT Management System",
        "Advanced Role Permissions",
        "API Integration Support",
        "Dedicated Account Manager",
      ],
      popular: false,
    },
  ];

  const faqs = [
    {
      question: "Is patient data secure?",
      answer:
        "Yes, all patient data is encrypted and stored on secure cloud servers with regular backups and compliance with healthcare data protection standards including HIPAA guidelines.",
    },
    {
      question: "Can I use this for small hospitals?",
      answer:
        "Absolutely! Aarogyasaarthi is specifically designed for 5-50 bed nursing homes and small hospitals with scalable features that grow with your needs.",
    },
    {
      question: "How much training is required?",
      answer:
        "Minimal training required. Our team provides complete setup within 1 day and comprehensive staff training to get you started quickly with ongoing support.",
    },
    {
      question: "Do you provide ongoing support?",
      answer:
        "Yes, we provide 24/7 technical support, regular updates, and dedicated customer success manager for Premium plans with guaranteed response times.",
    },
    {
      question: "What about data migration from existing systems?",
      answer:
        "We provide complete data migration services from your existing systems at no additional cost, ensuring zero data loss during transition.",
    },
  ];

  return (
    <div style={styles.container}>
      {/* Floating WhatsApp Button */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.floatingWhatsApp}
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={28} />
      </a>

      {/* Mobile Sticky Bottom Bar */}
      <div style={styles.mobileBottomBar} className="mobile-bottom-bar">
        <a href="tel:+916361748291" style={styles.bottomBarBtn}>
          <Phone size={20} />
          <span style={styles.bottomBarText}>Call</span>
        </a>
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={{ ...styles.bottomBarBtn, ...styles.bottomBarBtnWhatsApp }}
          onClick={() =>
            window.gtag &&
            window.gtag("event", "click_whatsapp", {
              event_category: "Mobile Bar",
            })
          }
        >
          <MessageCircle size={20} />
          <span style={styles.bottomBarText}>WhatsApp</span>
        </a>
        <a
          href="#demo"
          style={{ ...styles.bottomBarBtn, ...styles.bottomBarBtnDemo }}
          onClick={() =>
            window.gtag &&
            window.gtag("event", "click_book_demo", {
              event_category: "Mobile Bar",
            })
          }
        >
          <Calendar size={20} />
          <span style={styles.bottomBarText}>Demo</span>
        </a>
      </div>

      {/* Navigation */}
      <nav
        style={{
          ...styles.navbar,
          background:
            scrollY > 50
              ? "rgba(255, 255, 255, 0.95)"
              : "rgba(255, 255, 255, 0.9)",
          boxShadow:
            scrollY > 50
              ? "0 8px 32px rgba(0, 0, 0, 0.12)"
              : "0 2px 8px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={styles.navContainer}>
          <div style={styles.logoSection}>
            <img
              src="./assets/images/arrogya.svg"
              alt="Aarogyasaarthi"
              width="200"
              height="40"
              style={styles.logoImage}
            />
          </div>

          <div style={styles.navMenu} className="nav-menu">
            <a href="#home" style={styles.navLink}>
              Home
            </a>
            <a href="#features" style={styles.navLink}>
              Features
            </a>
            <a href="#pricing" style={styles.navLink}>
              Pricing
            </a>
            <a href="#demo" style={styles.navLink}>
              Demo
            </a>
            <a href="#support" style={styles.navLink}>
              Support
            </a>
          </div>

          <NavLink
            to="/login"
            style={styles.loginBtn}
            className="login-btn-desktop"
          >
            Login
          </NavLink>

          <button
            style={styles.mobileMenuBtn}
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div style={styles.mobileMenu}>
            <div style={styles.mobileMenuContent}>
              <a
                href="#home"
                style={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </a>
              <a
                href="#features"
                style={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                Features
              </a>
              <a
                href="#pricing"
                style={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </a>
              <a
                href="#demo"
                style={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                Demo
              </a>
              <a
                href="#support"
                style={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                Support
              </a>
              <NavLink
                to="/login"
                style={styles.mobileLoginBtn}
                onClick={() => setMobileMenuOpen(false)}
              >
                Login
              </NavLink>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" style={styles.hero}>
        <div style={styles.heroBackground}></div>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.heroContent} className="hero-content">
            {/* Left Content */}
            <div style={styles.heroText}>
              {/* <div style={styles.badge}>
                <Zap size={16} style={{ marginRight: "8px" }} />
                Go Live in 14 Days
              </div> */}

              <h1 style={styles.heroTitle} className="hero-title">
                Hospital Management Software for
                <span style={styles.gradientText}> 11–25 Bed</span> Nursing
                Homes
              </h1>

              <p style={styles.heroDescription} className="hero-description">
                OPD/IPD billing + Pharmacy stock + Reports — with online
                onboarding & staff training.
              </p>

              <div style={styles.goLiveBanner}>
                <Check size={20} style={styles.goLiveIcon} />
                <span style={styles.goLiveText}>
                  <strong>Go live in 14 days</strong> (guided implementation)
                </span>
              </div>

              <div style={styles.heroButtons} className="hero-buttons">
                <a
                  href="#demo"
                  style={styles.btnPrimary}
                  className="btn-primary"
                  onClick={() =>
                    window.gtag &&
                    window.gtag("event", "click_book_demo", {
                      event_category: "CTA",
                    })
                  }
                >
                  <Calendar size={20} style={{ marginRight: "8px" }} />
                  Book Free Demo
                </a>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.btnWhatsApp}
                  className="btn-secondary"
                  onClick={() =>
                    window.gtag &&
                    window.gtag("event", "click_whatsapp", {
                      event_category: "CTA",
                    })
                  }
                >
                  <MessageCircle size={20} style={{ marginRight: "8px" }} />
                  WhatsApp Us
                </a>
              </div>

              {/* Trust Bullets */}
              <div style={styles.trustBullets} className="trust-bullets">
                <div style={styles.trustBullet}>
                  <div style={styles.trustBulletIcon}>
                    <Monitor size={18} />
                  </div>
                  <span style={styles.trustBulletText}>
                    No on-site required (Online onboarding)
                  </span>
                </div>
                <div style={styles.trustBullet}>
                  <div style={styles.trustBulletIcon}>
                    <Smartphone size={18} />
                  </div>
                  <span style={styles.trustBulletText}>
                    Works on Mobile & Desktop
                  </span>
                </div>
                <div style={styles.trustBullet}>
                  <div style={styles.trustBulletIcon}>
                    <FileCheck size={18} />
                  </div>
                  <span style={styles.trustBulletText}>GST-ready billing</span>
                </div>
              </div>

              {/* Trust Badges */}
              {/* <div style={styles.trustBadges} className="trust-badges">
                <div style={styles.trustBadge}>
                  <div style={styles.trustNumber}>50+</div>
                  <div style={styles.trustLabel}>Hospitals</div>
                </div>
                <div style={styles.trustBadge}>
                  <div style={styles.trustNumber}>10,000+</div>
                  <div style={styles.trustLabel}>Patients</div>
                </div>
                <div style={styles.trustBadge}>
                  <div style={styles.trustNumber}>99.9%</div>
                  <div style={styles.trustLabel}>Uptime</div>
                </div>
              </div> */}
            </div>

            {/* Right Content - Hero Image */}
            <div style={styles.heroImageSection} className="hero-image-section">
              <div style={styles.heroImageCard}>
                <div style={styles.dashboardMockup}>
                  <div style={styles.mockupHeader}>
                    <div style={styles.mockupDots}>
                      <span style={styles.dot}></span>
                      <span style={styles.dot}></span>
                      <span style={styles.dot}></span>
                    </div>
                    <span style={styles.mockupTitle}>Hospital Dashboard</span>
                  </div>
                  <div style={styles.mockupContent}>
                    <div style={styles.mockupCards}>
                      <div style={styles.mockupCard}>
                        <Users size={20} />
                        <div>
                          <div style={styles.mockupCardTitle}>
                            Total Patients
                          </div>
                          <div style={styles.mockupCardValue}>1,248</div>
                        </div>
                      </div>
                      <div style={styles.mockupCard}>
                        <Calendar size={20} />
                        <div>
                          <div style={styles.mockupCardTitle}>
                            Today's Appointments
                          </div>
                          <div style={styles.mockupCardValue}>24</div>
                        </div>
                      </div>
                    </div>
                    <div style={styles.mockupChart}></div>
                  </div>
                </div>
                <div style={styles.floatingBadge1}>
                  <Check size={24} />
                </div>
                <div style={styles.floatingBadge2}>
                  <Shield size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Implementation Pricing Banner */}
      <section style={styles.implementationBanner}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.implementationContent}>
            <div style={styles.implementationBadge}>
              <Shield size={24} style={{ marginRight: "12px" }} />
              <div>
                <div style={styles.implementationTitle}>
                  Go-Live Pack: ₹19,999
                </div>
                <div style={styles.implementationSubtitle}>
                  Complete setup + data migration + staff training + 14-day
                  support
                </div>
              </div>
            </div>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.implementationBtn}
            >
              Get Started
              <ArrowRight size={20} style={{ marginLeft: "8px" }} />
            </a>
          </div>
        </div>
      </section>

      {/* Pain Points → Solution Section */}
      <section style={styles.painSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              From Manual Processes to Digital Excellence
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              Transform your hospital operations with our comprehensive digital
              solution
            </p>
          </div>

          <div style={styles.painGrid} className="pain-grid">
            {/* Challenges */}
            <div>
              <h3 style={styles.painTitle}>
                <span style={styles.painIcon}>❌</span>
                Current Challenges
              </h3>
              <div style={styles.painList}>
                {[
                  "Manual billing & paper records leading to errors",
                  "No proper patient history tracking system",
                  "Stock mismanagement in pharmacy inventory",
                  "Compliance issues with certificates & reports",
                  "Time-consuming appointment scheduling",
                  "Lack of real-time business insights",
                ].map((challenge, index) => (
                  <div key={index} style={styles.challengeCard}>
                    <p style={styles.cardText}>{challenge}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Solutions */}
            <div>
              <h3 style={styles.solutionTitle}>
                <span style={styles.solutionIcon}>✅</span>
                Aarogyasaarthi Solutions
              </h3>
              <div style={styles.painList}>
                {[
                  "Complete digital patient records with history",
                  "GST-ready billing & automated financial reports",
                  "Smart pharmacy & stock control system",
                  "Auto-generated birth & death certificates",
                  "Intelligent appointment scheduling system",
                  "Real-time analytics & business insights",
                ].map((solution, index) => (
                  <div key={index} style={styles.solutionCard}>
                    <p style={styles.cardText}>{solution}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof / Trust Section */}
      <section style={styles.trustSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.trustContent}>
            <h3 style={styles.trustTitle}>
              Trusted by Healthcare Providers Across India
            </h3>
            <div style={styles.trustStats} className="trust-stats">
              <div style={styles.trustStat}>
                <div style={styles.trustStatNumber}>500+</div>
                <div style={styles.trustStatLabel}>Hospitals Trust Us</div>
              </div>
              <div style={styles.trustStat}>
                <div style={styles.trustStatNumber}>10,000+</div>
                <div style={styles.trustStatLabel}>Patients</div>
              </div>
              <div style={styles.trustStat}>
                <div style={styles.trustStatNumber}>99.9%</div>
                <div style={styles.trustStatLabel}>System Uptime</div>
              </div>
              <div style={styles.trustStat}>
                <div style={styles.trustStatNumber}>24/7</div>
                <div style={styles.trustStatLabel}>Support Available</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Features Section */}
      <section id="features" style={styles.featuresSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              Complete Hospital Management Suite
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              Everything you need to run your hospital efficiently in one
              integrated platform
            </p>
          </div>

          <div style={styles.featuresGrid} className="features-grid">
            {features.map((feature, index) => (
              <div key={index} style={styles.featureCard}>
                <div style={styles.featureIcon}>{feature.icon}</div>
                <h3 style={styles.featureTitle}>{feature.title}</h3>
                <p style={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" style={styles.pricingSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              Simple, Transparent Pricing
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              Choose the perfect plan for your hospital size and requirements
            </p>
          </div>

          <div style={styles.pricingGrid} className="pricing-grid">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                style={{
                  ...styles.pricingCard,
                  ...(plan.popular ? styles.popularCard : {}),
                }}
              >
                {plan.popular && (
                  <div style={styles.popularBadge}>
                    <Star size={16} style={{ marginRight: "4px" }} />
                    Most Popular
                  </div>
                )}

                <div style={styles.pricingHeader}>
                  <h3 style={styles.planName}>{plan.name}</h3>
                  <p style={styles.planBeds}>{plan.beds}</p>
                  <div style={styles.planPrice}>
                    <span style={styles.priceAmount}>₹{plan.price}</span>
                    <span style={styles.priceUnit}>/month</span>
                  </div>

                  {plan.name === "Standard" && (
                    <div style={styles.goLivePackBox}>
                      <div style={styles.goLivePackTitle}>
                        <Check size={16} style={{ marginRight: "6px" }} />
                        Go-Live Pack (one-time): <strong>₹19,999</strong>
                      </div>
                      <p style={styles.goLivePackDesc}>
                        Online implementation + billing format + masters upload
                        + staff training + 14-day WhatsApp support
                      </p>
                    </div>
                  )}
                </div>

                <ul style={styles.featuresList}>
                  {plan.features.map((feature, fIndex) => (
                    <li key={fIndex} style={styles.featureItem}>
                      <Check size={18} style={styles.checkIcon} />
                      <span style={styles.featureText}>{feature}</span>
                    </li>
                  ))}
                </ul>

                <div style={styles.pricingButtonGroup}>
                  <a
                    href="#demo"
                    style={
                      plan.popular ? styles.popularButton : styles.pricingButton
                    }
                    onClick={() =>
                      window.gtag &&
                      window.gtag("event", "click_book_demo", {
                        event_category: "Pricing",
                      })
                    }
                  >
                    Book Free Demo
                  </a>
                  <a
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.pricingWhatsAppBtn}
                    onClick={() =>
                      window.gtag &&
                      window.gtag("event", "click_whatsapp", {
                        event_category: "Pricing",
                      })
                    }
                  >
                    <MessageCircle size={18} style={{ marginRight: "8px" }} />
                    WhatsApp Us
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Go-Live Pack Details Section */}
      <section style={styles.goLivePackSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              What's Included in the Go-Live Pack (Online)
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              Complete implementation support to get you started in 14 days
            </p>
          </div>

          <div style={styles.goLivePackContent}>
            <div style={styles.goLivePackGrid}>
              {[
                "Hospital profile + GST + bill format setup (OPD/IPD)",
                "User setup + roles (Reception/Billing/Doctor/Pharmacy/Admin)",
                "Masters setup support: Departments, Doctors, Services/Tariff",
                "Pharmacy setup: item import template + first upload support (up to 500 items)",
                "2 online training sessions (Reception/Billing + Pharmacy/Stock)",
                "14-day go-live WhatsApp support",
                "Recorded videos + Daily use checklist",
              ].map((item, index) => (
                <div key={index} style={styles.goLivePackItem}>
                  <Check size={20} style={styles.goLivePackIcon} />
                  <span style={styles.goLivePackText}>{item}</span>
                </div>
              ))}
            </div>

            <div style={styles.goLiveAddons}>
              <p style={styles.goLiveAddonsText}>
                <strong>Add-ons:</strong> Extra training ₹1,999 • Extra upload
                ₹2,999 • Data migration: quote after review
              </p>
            </div>

            <div style={styles.goLivePackButtons}>
              <a
                href="#demo"
                style={styles.goLivePackPrimaryBtn}
                onClick={() =>
                  window.gtag &&
                  window.gtag("event", "click_book_demo", {
                    event_category: "GoLive Pack",
                  })
                }
              >
                <Calendar size={20} style={{ marginRight: "8px" }} />
                Book Free Demo
              </a>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.goLivePackSecondaryBtn}
                onClick={() =>
                  window.gtag &&
                  window.gtag("event", "click_whatsapp", {
                    event_category: "GoLive Pack",
                  })
                }
              >
                <MessageCircle size={20} style={{ marginRight: "8px" }} />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Onboarding Steps - Updated to 14 Days */}
      <section style={styles.onboardingSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              Get Started in 4 Simple Steps
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              From signup to going live in just 14 days
            </p>
          </div>

          <div style={styles.stepsGrid} className="steps-grid">
            {[
              {
                icon: <UserCheck size={32} />,
                title: "Sign Up",
                desc: "Create your account and choose your plan",
                step: "1",
              },
              {
                icon: <Clock size={32} />,
                title: "Online Setup",
                desc: "Our team configures everything remotely",
                step: "2",
              },
              {
                icon: <Users size={32} />,
                title: "Staff Training",
                desc: "Comprehensive online training for your team",
                step: "3",
              },
              {
                icon: <Zap size={32} />,
                title: "Go Live",
                desc: "Start managing your hospital digitally",
                step: "4",
              },
            ].map((step, index) => (
              <div key={index} style={styles.stepCard}>
                <div style={styles.stepNumber}>{step.step}</div>
                <div style={styles.stepIcon}>{step.icon}</div>
                <h3 style={styles.stepTitle}>{step.title}</h3>
                <p style={styles.stepDesc}>{step.desc}</p>
              </div>
            ))}
          </div>

          <div style={styles.supportBadges}>
            <div style={styles.supportBadgeContainer}>
              <div style={styles.supportBadge}>
                <Shield size={24} style={styles.supportIcon} />
                <span style={styles.supportText}>24/7 Support</span>
              </div>
              <div style={styles.supportBadge}>
                <Check size={24} style={styles.supportIconGreen} />
                <span style={styles.supportText}>Data Security</span>
              </div>
              <div style={styles.supportBadge}>
                <Star size={24} style={styles.supportIconYellow} />
                <span style={styles.supportText}>Free Updates</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section - Updated */}
      <section id="demo" style={styles.demoSection}>
        <div style={styles.maxWidth} className="max-width">
          <div style={styles.demoContent}>
            <h2 style={styles.demoTitle} className="section-title">
              See OPD Billing + Pharmacy Stock Flow in 60 Seconds
            </h2>
            <p style={styles.demoSubtitle} className="section-subtitle">
              Quick walkthrough of the most-used features for 11-25 bed nursing
              homes
            </p>
            <div style={styles.demoVideoCard}>
              <div
                style={styles.demoVideoPlaceholder}
                onClick={() =>
                  window.gtag &&
                  window.gtag("event", "watch_demo_video", {
                    event_category: "Engagement",
                  })
                }
              >
                <Play size={64} style={styles.playIcon} />
                <p style={styles.demoVideoText}>Watch 60-Second Demo</p>
              </div>
            </div>

            {/* Demo Lead Form */}
            {!formSubmitted ? (
              <div style={styles.demoFormCard}>
                <h3 style={styles.demoFormTitle}>Book Your Free Demo</h3>
                <form onSubmit={handleFormSubmit} style={styles.demoForm}>
                  <div style={styles.formRow}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name *"
                      required
                      value={formData.name}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Mobile Number *"
                      required
                      value={formData.mobile}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formRow}>
                    <input
                      type="text"
                      name="hospitalName"
                      placeholder="Hospital/Nursing Home Name *"
                      required
                      value={formData.hospitalName}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                    <input
                      type="text"
                      name="city"
                      placeholder="City *"
                      required
                      value={formData.city}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div>
                  {/* <div style={styles.formRow}>
                    <select
                      name="bedCount"
                      value={formData.bedCount}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    >
                      <option value="5-10">5-10 Beds</option>
                      <option value="11-25">11-25 Beds</option>
                      <option value="26-50">26-50 Beds</option>
                      <option value="50+">50+ Beds</option>
                    </select>
                    <input
                      type="text"
                      name="role"
                      placeholder="Your Role (Owner/Manager) *"
                      required
                      value={formData.role}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formRow}>
                    <select
                      name="currentSystem"
                      value={formData.currentSystem}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    >
                      <option value="Manual">Manual (Paper-based)</option>
                      <option value="Excel">Excel/Spreadsheet</option>
                      <option value="Software">Existing Software</option>
                    </select>
                    <input
                      type="text"
                      name="preferredTime"
                      placeholder="Preferred Demo Time (Optional)"
                      value={formData.preferredTime}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div> */}

                  <div style={styles.formRow}>
                    <select
                      name="bedCount"
                      required
                      value={formData.bedCount}
                      onChange={handleFormChange}
                      style={{
                        ...styles.formInput,
                        color: formData.bedCount === "" ? "#94a3b8" : "#1e293b",
                        appearance: "none", // Default arrow hatane ke liye (optional)
                      }}
                    >
                      <option value="" disabled>
                        Select Bed Count *
                      </option>
                      <option value="5-10">5-10 Beds</option>
                      <option value="11-25">11-25 Beds</option>
                      <option value="26-50">26-50 Beds</option>
                      <option value="50+">50+ Beds</option>
                    </select>

                    <input
                      type="text"
                      name="role"
                      placeholder="Your Role (Owner/Manager) *"
                      required
                      value={formData.role}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div>

                  <div style={styles.formRow}>
                    <select
                      name="currentSystem"
                      required
                      value={formData.currentSystem}
                      onChange={handleFormChange}
                      style={{
                        ...styles.formInput,
                        color:
                          formData.currentSystem === "" ? "#94a3b8" : "#1e293b",
                      }}
                    >
                      <option value="" disabled>
                        Current System Used *
                      </option>
                      <option value="Manual">Manual (Paper-based)</option>
                      <option value="Excel">Excel/Spreadsheet</option>
                      <option value="Software">Existing Software</option>
                    </select>

                    <input
                      type="text"
                      name="preferredTime"
                      placeholder="Preferred Demo Time"
                      value={formData.preferredTime}
                      onChange={handleFormChange}
                      style={styles.formInput}
                    />
                  </div>
                  <button type="submit" style={styles.demoFormSubmitBtn}>
                    <Calendar size={20} style={{ marginRight: "8px" }} />
                    Book Free Demo
                  </button>
                </form>
              </div>
            ) : (
              <div style={styles.successMessage}>
                <Check
                  size={48}
                  style={{ color: "#16a34a", marginBottom: "16px" }}
                />
                <h3 style={{ marginBottom: "12px", fontSize: "24px" }}>
                  Thank You!
                </h3>
                <p style={{ marginBottom: "20px" }}>
                  We'll WhatsApp you the demo + 14-day go-live plan shortly.
                </p>
                <p style={{ fontSize: "14px", opacity: 0.8 }}>
                  Redirecting to WhatsApp...
                </p>
              </div>
            )}

            <div style={styles.demoButtons} className="demo-buttons">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.demoSecondaryBtn}
                className="demo-btn"
                onClick={() =>
                  window.gtag &&
                  window.gtag("event", "click_whatsapp", {
                    event_category: "Demo",
                  })
                }
              >
                <MessageCircle size={20} style={{ marginRight: "8px" }} />
                Schedule on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" style={styles.faqSection}>
        <div style={styles.faqContainer}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle} className="section-title">
              Frequently Asked Questions
            </h2>
            <p style={styles.sectionSubtitle} className="section-subtitle">
              Everything you need to know about Aarogyasaarthi
            </p>
          </div>

          <div style={styles.faqList}>
            {faqs.map((faq, index) => (
              <div key={index} style={styles.faqItem}>
                <button
                  onClick={() =>
                    setActiveFaq(activeFaq === index ? null : index)
                  }
                  style={styles.faqQuestion}
                >
                  <h3 style={styles.faqQuestionText}>{faq.question}</h3>
                  <ChevronDown
                    size={20}
                    style={{
                      ...styles.faqIcon,
                      transform:
                        activeFaq === index ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </button>
                {activeFaq === index && (
                  <div style={styles.faqAnswer}>
                    <p style={styles.faqAnswerText}>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section id="support" style={styles.ctaSection}>
        <div style={styles.ctaContainer}>
          <h2 style={styles.ctaTitle} className="section-title">
            Run Your Hospital Smarter with Aarogyasaarthi
          </h2>
          <p style={styles.ctaSubtitle} className="section-subtitle">
            Join hundreds of healthcare providers who have transformed their
            operations with our platform
          </p>

          <div style={styles.ctaButtons} className="cta-buttons">
            <a href="#demo" style={styles.ctaPrimary} className="cta-btn">
              Book Free Demo
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.ctaSecondary}
              className="cta-btn"
            >
              WhatsApp Us
            </a>
          </div>

          <div style={styles.contactInfo} className="contact-info">
            <a href="tel:+916361748291" style={styles.contactItem}>
              <Phone size={20} style={{ marginRight: "8px" }} />
              +91 6361748291
            </a>
            <a
              href="mailto:info@bbstechsolutions.com"
              style={styles.contactItem}
            >
              <Mail size={20} style={{ marginRight: "8px" }} />
              info@bbstechsolutions.com
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.contactItem}
            >
              <MessageCircle size={20} style={{ marginRight: "8px" }} />
              WhatsApp Support
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    lineHeight: "1.6",
    color: "#333",
  },

  // Floating WhatsApp Button
  floatingWhatsApp: {
    position: "fixed",
    bottom: "100px",
    right: "24px",
    width: "60px",
    height: "60px",
    backgroundColor: "#25D366",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)",
    zIndex: 1000,
    cursor: "pointer",
    transition: "all 0.3s ease",
    animation: "pulse 2s infinite",
    textDecoration: "none",
  },

  // Mobile Bottom Bar
  mobileBottomBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    display: "none",
    gridTemplateColumns: "1fr 1fr 1fr",
    boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
    zIndex: 999,
    borderTop: "1px solid #e2e8f0",
  },
  bottomBarBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    textDecoration: "none",
    color: "#64748b",
    transition: "all 0.3s ease",
    gap: "4px",
  },
  bottomBarBtnWhatsApp: {
    backgroundColor: "#f0fdf4",
    color: "#16a34a",
  },
  bottomBarBtnDemo: {
    backgroundColor: "#eff6ff",
    color: "#2563eb",
  },
  bottomBarText: {
    fontSize: "11px",
    fontWeight: "600",
  },

  // Navigation Styles
  navbar: {
    position: "fixed",
    width: "100%",
    top: 0,
    zIndex: 1000,
    padding: "16px 0",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  navContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
  },
  logoImage: {
    maxHeight: "40px",
    width: "auto",
  },
  navMenu: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
  },
  navLink: {
    textDecoration: "none",
    color: "#64748b",
    fontWeight: "500",
    fontSize: "16px",
    transition: "color 0.3s ease",
    cursor: "pointer",
  },
  loginBtn: {
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    color: "white",
    padding: "12px 28px",
    border: "none",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
    textDecoration: "none",
    display: "inline-block",
  },
  mobileMenuBtn: {
    display: "none",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#64748b",
  },
  mobileMenu: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    background: "white",
    borderTop: "1px solid #e2e8f0",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    zIndex: 999,
  },
  mobileMenuContent: {
    padding: "16px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  mobileNavLink: {
    textDecoration: "none",
    color: "#64748b",
    fontWeight: "500",
    fontSize: "16px",
    padding: "12px 0",
    borderBottom: "1px solid #f1f5f9",
    cursor: "pointer",
  },
  mobileLoginBtn: {
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    color: "white",
    padding: "12px 24px",
    border: "none",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "8px",
    textDecoration: "none",
    display: "block",
    textAlign: "center",
    width: "100%",
  },

  // Hero Section Styles
  hero: {
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    padding: "120px 0 60px",
    position: "relative",
    overflow: "hidden",
    minHeight: "90vh",
    display: "flex",
    alignItems: "center",
  },
  heroBackground: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%)",
    backdropFilter: "blur(100px)",
  },
  maxWidth: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
    position: "relative",
    zIndex: 1,
  },
  heroContent: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "64px",
    alignItems: "center",
  },
  heroText: {
    zIndex: 2,
    position: "relative",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
    color: "#16a34a",
    borderRadius: "25px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "24px",
    border: "1px solid rgba(22, 163, 74, 0.2)",
  },
  heroTitle: {
    fontSize: "3.5rem",
    fontWeight: "800",
    lineHeight: "1.1",
    marginBottom: "24px",
    color: "#1e293b",
  },
  gradientText: {
    background: "linear-gradient(135deg, #16a34a 0%, #2563eb 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  heroDescription: {
    fontSize: "1.25rem",
    marginBottom: "20px",
    color: "#64748b",
    lineHeight: "1.7",
    maxWidth: "540px",
  },
  goLiveBanner: {
    display: "inline-flex",
    alignItems: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
    color: "#1e40af",
    borderRadius: "12px",
    padding: "12px 20px",
    marginBottom: "32px",
    border: "1px solid rgba(37, 99, 235, 0.2)",
  },
  goLiveIcon: {
    marginRight: "10px",
    flexShrink: 0,
  },
  goLiveText: {
    fontSize: "15px",
    fontWeight: "500",
  },
  heroButtons: {
    display: "flex",
    gap: "16px",
    marginBottom: "32px",
  },
  btnPrimary: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "18px 36px",
    border: "none",
    borderRadius: "50px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
    textDecoration: "none",
  },
  btnWhatsApp: {
    background: "#25D366",
    color: "white",
    padding: "18px 36px",
    border: "none",
    borderRadius: "50px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    boxShadow: "0 8px 25px rgba(37, 211, 102, 0.3)",
    textDecoration: "none",
  },
  trustBullets: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "32px",
  },
  trustBullet: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "white",
    padding: "12px 16px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    border: "1px solid #e2e8f0",
  },
  trustBulletIcon: {
    backgroundColor: "#f0f9ff",
    color: "#2563eb",
    borderRadius: "8px",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  trustBulletText: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#334155",
    lineHeight: "1.3",
  },
  trustBadges: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "32px",
    marginTop: "32px",
  },
  trustBadge: {
    textAlign: "center",
  },
  trustNumber: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "8px",
    color: "#1e293b",
    background: "linear-gradient(135deg, #2563eb 0%, #16a34a 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  trustLabel: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: "500",
  },

  // Hero Image Section
  heroImageSection: {
    position: "relative",
  },
  heroImageCard: {
    position: "relative",
    background: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(20px)",
    borderRadius: "24px",
    padding: "24px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    marginTop: "-180px",
  },
  dashboardMockup: {
    background: "white",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
  },
  mockupHeader: {
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    padding: "16px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  mockupDots: {
    display: "flex",
    gap: "6px",
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.3)",
  },
  mockupTitle: {
    color: "white",
    fontSize: "14px",
    fontWeight: "600",
  },
  mockupContent: {
    padding: "20px",
  },
  mockupCards: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "20px",
  },
  mockupCard: {
    background: "#f8fafc",
    padding: "16px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  mockupCardTitle: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "4px",
  },
  mockupCardValue: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1e293b",
  },
  mockupChart: {
    height: "80px",
    background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
    borderRadius: "8px",
    position: "relative",
  },
  floatingBadge1: {
    position: "absolute",
    top: "-12px",
    right: "-12px",
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "12px",
    borderRadius: "50%",
    boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
    animation: "float 3s ease-in-out infinite",
  },
  floatingBadge2: {
    position: "absolute",
    bottom: "-12px",
    left: "-12px",
    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    color: "white",
    padding: "12px",
    borderRadius: "50%",
    boxShadow: "0 8px 25px rgba(37, 99, 235, 0.3)",
    animation: "float 3s ease-in-out infinite 1.5s",
  },

  // Implementation Banner
  implementationBanner: {
    backgroundColor: "#1e293b",
    padding: "24px 0",
    borderTop: "2px solid #16a34a",
  },
  implementationContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "20px",
  },
  implementationBadge: {
    display: "flex",
    alignItems: "center",
    color: "white",
  },
  implementationTitle: {
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "4px",
    color: "#10b981",
  },
  implementationSubtitle: {
    fontSize: "14px",
    color: "#94a3b8",
  },
  implementationBtn: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "14px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(22, 163, 74, 0.3)",
  },

  // Pain Points Section
  painSection: {
    padding: "80px 0",
    background: "#f8fafc",
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: "60px",
  },
  sectionTitle: {
    fontSize: "2.5rem",
    fontWeight: "800",
    color: "#1e293b",
    marginBottom: "20px",
    lineHeight: "1.2",
  },
  sectionSubtitle: {
    fontSize: "1.25rem",
    color: "#64748b",
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: "1.6",
  },
  painGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "60px",
  },
  painTitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: "#dc2626",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
  },
  solutionTitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: "#16a34a",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
  },
  painIcon: {
    background: "#fee2e2",
    padding: "12px",
    borderRadius: "50%",
    marginRight: "16px",
    fontSize: "20px",
  },
  solutionIcon: {
    background: "#dcfce7",
    padding: "12px",
    borderRadius: "50%",
    marginRight: "16px",
    fontSize: "20px",
  },
  painList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  challengeCard: {
    background: "white",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
    borderLeft: "4px solid #dc2626",
    transition: "all 0.3s ease",
  },
  solutionCard: {
    background: "white",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
    borderLeft: "4px solid #16a34a",
    transition: "all 0.3s ease",
  },
  cardText: {
    margin: 0,
    color: "#374151",
    lineHeight: "1.6",
    fontSize: "16px",
  },

  // Trust Section
  trustSection: {
    padding: "60px 0",
    background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
    color: "white",
  },
  trustContent: {
    textAlign: "center",
  },
  trustTitle: {
    fontSize: "2rem",
    fontWeight: "700",
    marginBottom: "40px",
  },
  trustStats: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "32px",
  },
  trustStat: {
    textAlign: "center",
    padding: "20px",
  },
  trustStatNumber: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "8px",
    background: "linear-gradient(135deg, #16a34a 0%, #2563eb 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  trustStatLabel: {
    fontSize: "14px",
    opacity: 0.8,
  },

  // Features Section
  featuresSection: {
    padding: "80px 0",
    background: "white",
  },
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "32px",
  },
  featureCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "32px",
    borderRadius: "16px",
    textAlign: "center",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
  },
  featureIcon: {
    background: "rgba(255, 255, 255, 0.2)",
    borderRadius: "16px",
    width: "64px",
    height: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
    backdropFilter: "blur(10px)",
  },
  featureTitle: {
    fontSize: "1.25rem",
    fontWeight: "700",
    marginBottom: "16px",
  },
  featureDescription: {
    opacity: 0.9,
    lineHeight: "1.6",
    fontSize: "16px",
  },

  // Pricing Section
  pricingSection: {
    padding: "80px 0",
    background: "#f8fafc",
  },
  pricingGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "32px",
  },
  pricingCard: {
    background: "white",
    borderRadius: "16px",
    padding: "32px",
    textAlign: "center",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    position: "relative",
    transition: "all 0.3s ease",
  },
  popularCard: {
    border: "2px solid #2563eb",
    transform: "scale(1.02)",
    boxShadow: "0 16px 32px rgba(37, 99, 235, 0.2)",
  },
  popularBadge: {
    position: "absolute",
    top: "-12px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    color: "white",
    padding: "8px 20px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
  },
  pricingHeader: {
    marginBottom: "24px",
  },
  planName: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "8px",
  },
  planBeds: {
    fontSize: "14px",
    color: "#64748b",
    marginBottom: "16px",
  },
  planPrice: {
    marginBottom: "16px",
  },
  priceAmount: {
    fontSize: "2.5rem",
    fontWeight: "800",
    color: "#1e293b",
  },
  priceUnit: {
    fontSize: "16px",
    color: "#64748b",
    fontWeight: "500",
  },
  goLivePackBox: {
    background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
    border: "2px solid #16a34a",
    borderRadius: "12px",
    padding: "16px",
    marginTop: "16px",
    textAlign: "left",
  },
  goLivePackTitle: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#15803d",
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
  },
  goLivePackDesc: {
    fontSize: "13px",
    color: "#166534",
    lineHeight: "1.5",
    margin: 0,
  },
  featuresList: {
    listStyle: "none",
    padding: 0,
    margin: "0 0 24px 0",
    textAlign: "left",
  },
  featureItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "10px",
    gap: "8px",
  },
  checkIcon: {
    color: "#16a34a",
    marginTop: "2px",
    flexShrink: 0,
  },
  featureText: {
    color: "#374151",
    fontSize: "15px",
    lineHeight: "1.5",
  },
  pricingButtonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  pricingButton: {
    background: "transparent",
    color: "#2563eb",
    border: "2px solid #2563eb",
    padding: "12px 24px",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    width: "100%",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "block",
  },
  popularButton: {
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    width: "100%",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
    textDecoration: "none",
    display: "block",
  },
  pricingWhatsAppBtn: {
    background: "#25D366",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "25px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    width: "100%",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // Go-Live Pack Section
  goLivePackSection: {
    padding: "80px 0",
    background: "white",
  },
  goLivePackContent: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  goLivePackGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
    marginBottom: "32px",
  },
  goLivePackItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    background: "#f8fafc",
    padding: "16px 20px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
  },
  goLivePackIcon: {
    color: "#16a34a",
    flexShrink: 0,
    marginTop: "2px",
  },
  goLivePackText: {
    fontSize: "16px",
    color: "#334155",
    lineHeight: "1.6",
  },
  goLiveAddons: {
    background: "#fef3c7",
    border: "1px solid #fbbf24",
    borderRadius: "12px",
    padding: "16px 20px",
    marginBottom: "32px",
  },
  goLiveAddonsText: {
    fontSize: "14px",
    color: "#92400e",
    margin: 0,
    lineHeight: "1.6",
  },
  goLivePackButtons: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  goLivePackPrimaryBtn: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "16px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 4px 15px rgba(22, 163, 74, 0.3)",
  },
  goLivePackSecondaryBtn: {
    background: "#25D366",
    color: "white",
    padding: "16px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 4px 15px rgba(37, 211, 102, 0.3)",
  },

  // Onboarding Steps
  onboardingSection: {
    padding: "80px 0",
    background: "white",
  },
  stepsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "32px",
    marginBottom: "48px",
  },
  stepCard: {
    textAlign: "center",
    position: "relative",
    padding: "24px 16px",
  },
  stepNumber: {
    position: "absolute",
    top: "-12px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
    color: "white",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "700",
  },
  stepIcon: {
    background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
    borderRadius: "12px",
    width: "64px",
    height: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 16px",
    color: "#475569",
  },
  stepTitle: {
    fontSize: "1.1rem",
    fontWeight: "700",
    marginBottom: "8px",
    color: "#1e293b",
  },
  stepDesc: {
    color: "#64748b",
    lineHeight: "1.5",
    fontSize: "14px",
  },
  onboardingButtons: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  onboardingPrimaryBtn: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "14px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "17px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
    boxShadow: "0 4px 15px rgba(22, 163, 74, 0.3)",
  },
  onboardingSecondaryBtn: {
    background: "#25D366",
    color: "white",
    padding: "14px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "17px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
    boxShadow: "0 4px 15px rgba(37, 211, 102, 0.3)",
  },
  supportBadges: {
    display: "flex",
    justifyContent: "center",
  },
  supportBadgeContainer: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  supportBadge: {
    display: "flex",
    alignItems: "center",
    background: "#f8fafc",
    padding: "10px 16px",
    borderRadius: "20px",
    border: "1px solid #e2e8f0",
  },
  supportIcon: {
    color: "#2563eb",
    marginRight: "6px",
  },
  supportIconGreen: {
    color: "#16a34a",
    marginRight: "6px",
  },
  supportIconYellow: {
    color: "#eab308",
    marginRight: "6px",
  },
  supportText: {
    color: "#374151",
    fontSize: "13px",
    fontWeight: "500",
  },

  // Demo Section
  demoSection: {
    padding: "80px 0",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
  },
  demoContent: {
    textAlign: "center",
  },
  demoTitle: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "20px",
    lineHeight: "1.2",
  },
  demoSubtitle: {
    fontSize: "1.25rem",
    marginBottom: "40px",
    opacity: 0.9,
    maxWidth: "600px",
    margin: "0 auto 40px",
  },
  demoVideoCard: {
    background: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(20px)",
    borderRadius: "16px",
    padding: "32px",
    marginBottom: "32px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  demoVideoPlaceholder: {
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "12px",
    padding: "48px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  playIcon: {
    background: "rgba(255, 255, 255, 0.2)",
    borderRadius: "50%",
    padding: "16px",
    marginBottom: "12px",
  },
  demoVideoText: {
    fontSize: "16px",
    fontWeight: "600",
    margin: 0,
  },

  demoFormCard: {
    background: "#fff",
    padding: "32px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
    marginBottom: "20px",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "16px", // Har row ke niche thoda space
  },
  formInput: {
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    fontSize: "15px",
    fontFamily: "inherit",
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "#f8fafc", // Thoda off-white background taaki premium lage
    height: "48px", // Fixed height taaki text kate nahi
    transition: "border-color 0.2s ease",
  },
  demoFormSubmitBtn: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#16a34a",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
  },

  // demoFormCard: {
  //   background: "white",
  //   borderRadius: "16px",
  //   padding: "32px",
  //   marginBottom: "32px",
  //   maxWidth: "800px",
  //   margin: "0 auto 32px",
  //   color: "#1e293b",
  // },
  demoFormTitle: {
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "24px",
    color: "#1e293b",
  },
  demoForm: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  // formRow: {
  //   display: "grid",
  //   gridTemplateColumns: "1fr 1fr",
  //   gap: "16px",
  // },
  // formInput: {
  //   padding: "14px 16px",
  //   borderRadius: "8px",
  //   border: "1px solid #e2e8f0",
  //   fontSize: "15px",
  //   fontFamily: "inherit",
  //   width: "100%",
  //   boxSizing: "border-box",
  // },
  // demoFormSubmitBtn: {
  //   background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
  //   color: "white",
  //   padding: "16px 32px",
  //   border: "none",
  //   borderRadius: "25px",
  //   fontSize: "18px",
  //   fontWeight: "600",
  //   cursor: "pointer",
  //   transition: "all 0.3s ease",
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   boxShadow: "0 4px 15px rgba(22, 163, 74, 0.3)",
  // },
  successMessage: {
    background: "white",
    borderRadius: "16px",
    padding: "48px 32px",
    marginBottom: "32px",
    maxWidth: "600px",
    margin: "0 auto 32px",
    color: "#1e293b",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  demoButtons: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
  },
  demoPrimaryBtn: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "14px 28px",
    border: "none",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
  },
  demoSecondaryBtn: {
    background: "rgba(255, 255, 255, 0.2)",
    color: "white",
    padding: "14px 28px",
    border: "2px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },

  // FAQ Section
  faqSection: {
    padding: "80px 0",
    background: "white",
  },
  faqContainer: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "0 20px",
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  faqItem: {
    background: "white",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    overflow: "hidden",
    marginBottom: "8px",
  },
  faqQuestion: {
    width: "100%",
    padding: "20px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "all 0.3s ease",
  },
  faqQuestionText: {
    fontSize: "17px",
    fontWeight: "600",
    color: "#1e293b",
    textAlign: "left",
    margin: 0,
  },
  faqIcon: {
    color: "#64748b",
    transition: "transform 0.3s ease",
    flexShrink: 0,
    marginLeft: "12px",
  },
  faqAnswer: {
    padding: "0 20px 20px",
    borderTop: "1px solid #f1f5f9",
  },
  faqAnswerText: {
    color: "#64748b",
    lineHeight: "1.6",
    margin: 0,
    fontSize: "15px",
  },

  // Final CTA Section
  ctaSection: {
    padding: "80px 0",
    background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
    color: "white",
  },
  ctaContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "20px",
    lineHeight: "1.2",
  },
  ctaSubtitle: {
    fontSize: "1.25rem",
    marginBottom: "40px",
    opacity: 0.9,
    maxWidth: "600px",
    margin: "0 auto 40px",
  },
  ctaButtons: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginBottom: "48px",
  },
  ctaPrimary: {
    background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
    color: "white",
    padding: "16px 32px",
    border: "none",
    borderRadius: "25px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 8px 25px rgba(22, 163, 74, 0.3)",
    textDecoration: "none",
    display: "inline-block",
  },
  ctaSecondary: {
    background: "transparent",
    color: "white",
    padding: "16px 32px",
    border: "2px solid rgba(255, 255, 255, 0.3)",
    borderRadius: "25px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
  },
  contactInfo: {
    display: "flex",
    gap: "24px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    color: "white",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "500",
    padding: "12px 20px",
    background: "rgba(255, 255, 255, 0.1)",
    borderRadius: "25px",
    transition: "all 0.3s ease",
  },
};

export default LandingPage;
